import "./Gallery.css";
import React from "react";
import { Grid } from "react-bootstrap";
import { PulseLoader } from "react-spinners";
import AvatarEditor from "react-avatar-editor";
import { compress } from "../../services/compressor";
import Button from "../../elements/CustomButton/CustomButton.jsx";

import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { db, storage, keygen } from "../../services/firebase";
import { faTimes } from "@fortawesome/fontawesome-free-solid";

export default class Gallery extends React.Component {
  constructor(props) {
    super(props);
    this.notify = props.notify;
    this.companyID = props.companyID;
    this.handleClose = props.handleClose;
    this.targetProduct = props.targetProduct;

    this.state = {
      loading: true,
      images: [],
      file: null,
      rotate: 0,
      scale: 1,
      sendingImage: false,
      updatingImage: false,
      removingImage: false,
      selected: null,
    };
  }

  componentDidMount() {
    this._fetch();
    this.setState({ selected: this.props.targetProduct.image || null });
  }

  render() {
    return (
      <div>
        <Grid fluid>
          <FontAwesomeIcon
            className="text-default gallery__close"
            onClick={this.props.handleClose}
            icon={faTimes}
          />
          <input
            ref={(fileInput) => (this.fileInput = fileInput)}
            style={{ display: "none" }}
            type="file"
            accept="image/jpg"
            onChange={this._handleFileInput}
          />
          {this._handleContent()}
        </Grid>
      </div>
    );
  }

  //handlers
  _handleFileInput = (e) => {
    let reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onload = () => this.setState({ file: reader.result });
    reader.onerror = (err) =>
      this.props.notify("Erro ao carregar imagem. Tente novamente", "error");
  };

  _handleScale = (e) => this.setState({ scale: parseFloat(e.target.value) });

  _increaseRotation = () => this.setState({ rotate: this.state.rotate + 90 });

  _decreaseRotation = () => this.setState({ rotate: this.state.rotate - 90 });

  _handleContent = () => {
    const {
      loading,
      images,
      file,
      sendingImage,
      updatingImage,
      removingImage,
      selected,
    } = this.state;

    if (loading && !images.length && !file) {
      return <h2>Carregando imagens</h2>;
    }

    if (!loading && !images.length && !file) {
      return (
        <div className="gallery__empty-wrapper">
          <div className="gallery__empty">
            <h3 className="gallery__empty--text">
              Nenhuma imagem cadastrada
              <br />
              <small>Adicione uma imagem clicando no botão abaixo</small>
              <br />
            </h3>
            <Button
              className="gallery__add-image"
              bsStyle="default"
              fill
              onClick={() => this.fileInput.click()}
            >
              Adicionar imagem
            </Button>
          </div>
        </div>
      );
    }

    if (file) {
      const { file, scale, rotate } = this.state;
      return (
        <div className="gallery__new-image">
          <div className="gallery__canvas-wrapper">
            <AvatarEditor
              ref={(editor) => (this.editor = editor)}
              image={file}
              width={350}
              height={350}
              border={20}
              color={[0, 0, 0, 0.7]}
              scale={parseFloat(scale)}
              rotate={rotate}
            />

            <div className="gallery__canvas-controls">
              <input
                className="sld"
                name="scale"
                type="range"
                onChange={this._handleScale}
                min="1"
                max="5"
                step="0.01"
                defaultValue="1"
                disabled={sendingImage}
              />
            </div>

            <div className="gallery__upload-controls">
              <Button
                bsStyle="default"
                fill
                disabled={sendingImage}
                onClick={() => {
                  this.setState({ sendingImage: true });
                  compress(this.editor.getImage().toDataURL("image/jpg", 0.7))
                    .then((img) => {
                      let key = keygen();
                      storage
                        .ref()
                        .child(`products/${key}.jpg`)
                        .put(img)
                        .then((storageResponse) => {
                          db.collection("products_images")
                            .doc(key)
                            .set({ downloadURL: storageResponse.downloadURL })
                            .then(() => {
                              this.setState({
                                file: null,
                                scale: 1,
                                sendingImage: false,
                              });
                            })
                            .catch((e) =>
                              this.props.notify(
                                "Erro ao adicionar referências a imagem",
                                "error"
                              )
                            );
                        })
                        .catch((e) =>
                          this.props.notify("Erro ao armazenar imagem", "error")
                        );
                    })
                    .catch((e) =>
                      this.props.notify("Erro ao comprimir imagem", "error")
                    );
                }}
              >
                {sendingImage ? (
                  <PulseLoader color={"#6C1137"} size={7} />
                ) : (
                  "Salvar Imagem"
                )}
              </Button>
            </div>
          </div>
        </div>
      );
    }

    if (file && sendingImage) {
      return <h2>Aguarde, salvando imagem</h2>;
    }

    if (!loading && images.length) {
      return (
        <div className="gallery__list">
          <div className="gallery__header">
            <Button
              className="gallery__header-button-new pull-right"
              bsStyle="default"
              fill
              disabled={updatingImage || removingImage}
              onClick={() => this.fileInput.click()}
            >
              {updatingImage ? (
                <PulseLoader color={"#6C1137"} size={7} />
              ) : (
                "Adicionar imagem"
              )}
            </Button>

            <Button
              className="gallery__header-button-select"
              bsStyle="default"
              fill
              disabled={!selected || updatingImage || removingImage}
              onClick={() =>
                this._updateProductImage(
                  this.props.companyID,
                  this.props.targetProduct.id,
                  selected
                )
              }
            >
              {updatingImage ? (
                <PulseLoader color={"#6C1137"} size={7} />
              ) : (
                "Usar imagem"
              )}
            </Button>

            {/* <Button
                            className="gallery__header-button-remove"
                            bsStyle="danger"
                            fill
                            disabled={!selected || updatingImage || removingImage}
                            onClick={() => this._removeImage(selected)}
                        >
                            {updatingImage ? (<PulseLoader color={'#6C1137'} size={7} />) : 'Excluir imagem'}
                        </Button> */}
          </div>
          {images.map((image, index) => (
            <img
              className={selected === image.id && "gallery__selected"}
              onClick={() => this.setState({ selected: image.id })}
              key={index}
              src={image.downloadURL}
              alt={`product_${index}`}
              width="196.25"
              height="196.25"
              style={{
                marginRight: (index + 1) % 4 !== 0 ? 5 : 0,
                marginBottom: 5,
              }}
            />
          ))}
        </div>
      );
    }
  };

  //data
  _fetch = () => {
    db.collection("products_images").onSnapshot((imageSnapshot) => {
      const images = [];
      if (!imageSnapshot.empty) {
        imageSnapshot.forEach((img) =>
          images.push({ downloadURL: img.data().downloadURL, id: img.id })
        );
        this.setState({ loading: false, images });
      } else {
        this.setState({ loading: false, images });
      }
    });
  };

  _updateProductImage = (companyID, productID, imageID) => {
    db.collection("companies")
      .doc(companyID)
      .collection("products")
      .doc(productID)
      .update({ image: imageID })
      .then(() => {
        this.props.handleClose();
        this.props.notify("Alterações salvas", "success");
      })
      .catch((e) => {
        this.props.notify(
          "Erro ao salvar as alterações. Tente novamente",
          "error"
        );
      });
  };

  // _removeImage = imageID => {
  //     const dependencies = []
  //     const PromiseStack = []

  //     this.setState({ removingImage: true })

  //     db.collection('companies').get()
  //         .then(companySnapshot => {
  //             companySnapshot.forEach(company => {
  //                 PromiseStack.push(
  //                     db.collection('companies')
  //                         .doc(company.id)
  //                         .collection('products')
  //                         .where('image', '==', imageID)
  //                         .get()
  //                         .then(productSnapshot => {
  //                             if (!productSnapshot.empty) {
  //                                 productSnapshot.forEach(product => dependencies.push(product.id))
  //                             }
  //                         })
  //                         .catch(e => console.log(e))
  //                 )
  //             })

  //             Promise.all(PromiseStack)
  //                 .then(() => {
  //                     if (dependencies.length) {
  //                         this.setState({ removingImage: false })
  //                         this.props.notify(`Você não pode remover esta imagem, ela está sendo utilizada por ${dependencies.length} ${dependencies.length > 1 ? 'produtos' : 'produto'}`, 'warning')
  //                     } else {
  //                         storage.ref().child(`products/${imageID}.jpg`).delete()
  //                             .then(() => {
  //                                 db.collection('product_images').doc(imageID).delete()
  //                                     .then(() => {
  //                                         this.setState({ removingImage: false })
  //                                         this.props.notify('Imagem removida', 'success')
  //                                     })
  //                                     .catch(e => {
  //                                         this.setState({ removingImage: false })
  //                                         this.props.notify('Erro ao apagar referência da imagem', 'error')
  //                                     })
  //                             })
  //                             .catch(e => {
  //                                 this.setState({ removingImage: false })
  //                                 this.props.notify('Erro ao excluir a imagem. Tente novamente', 'error')
  //                             })
  //                     }
  //                 })
  //                 .catch(e => this.props.notify('Erro ao validar dependências.', 'error'))
  //         })
  // }
}



// WEBPACK FOOTER //
// ./src/components/Gallery/Gallery.jsx